import modal from '../../styles/objects/modal'

export default modal



// WEBPACK FOOTER //
// ./components/modal/styles.js